export default __webpack_public_path__ + "static/media/Arrow-1.db801ac3.svg";